import { CONFIG_PARAMETERS_KEY } from 'phoenix2/state/config-params/reducers';

export const getConfigParameter = (state, parameterName) =>
    state.getIn([CONFIG_PARAMETERS_KEY, parameterName], null);
